<template>
  <div class="header-sidebar">
    <logo
      :is-mini-sidebar="isMiniSidebar"
      @image-clicked="imageClicked"
    />
    <menu-list
      :items="menuItems"
      :is-mini-sidebar="isMiniSidebar"
    />
  </div>
</template>

<script>

import Logo from './Logo.vue'
import MenuList from './MenuList'

export default {
  components: {
    Logo,
    MenuList
  },

  props: {
    isMiniSidebar: {
      type: Boolean,
      default: false
    },
    menuItems: {
      type: Array,
      default: () => ([])
    }
  },

  methods: {
    imageClicked() {
      this.$emit('image-clicked')
    }
  }
}
</script>

<style lang="sass" scoped>
.sidebar-link .v-list__tile__action, .v-list__tile__avatar
  min-width: 40px !important

.header-sidebar
  .sidebar-link
    .v-list__tile__title
      font-size: 14px
  .sidebar-active-link, .sidebar-link:hover
    background: $hwayzBrandBlue !important
    .v-list__tile__title
      color: $hwayzWhite !important
      font-family: Roboto,sans-serif
    i
      color: $hwayzWhite !important

.v-list
  padding-bottom: 0 !important

.sidebar-agent__signout
  margin-top: 150px
  padding: 1.5rem 0rem !important
  @media only screen and (min-width: 600px)
    padding: 2rem 0.5rem !important
  @media only screen and (min-width: 960px)
    padding: 2rem 1rem !important
</style>
